import React from "react";
import {
  AdminPanelSettings,
  Assessment,
  CreditCard,
  Dashboard,
  Group,
  HelpOutline,
  Link,
  LiveTv,
  ReceiptLong,
  Videocam,
  YouTube,
} from "@mui/icons-material";
import { ADMIN_ROLES, GLOBAL_ROLES, OPERATIONAL_ROLES } from "./roles";
import { EUserRole } from "../types/enums";

export type NavigationOption = {
  nameKey: string;
  route: string;
  icon: React.ReactElement;
  roles: EUserRole[];
};

export const navigationOptions: NavigationOption[] = [
  { nameKey: "dashboard", route: "/dashboard", icon: React.createElement(Dashboard), roles: OPERATIONAL_ROLES },
  { nameKey: "cameras", route: "/cameras", icon: React.createElement(Videocam), roles: OPERATIONAL_ROLES },
  { nameKey: "liveStreams", route: "/transmissoes-ao-vivo", icon: React.createElement(LiveTv), roles: OPERATIONAL_ROLES },
  { nameKey: "subscriptions", route: "/assinaturas", icon: React.createElement(CreditCard), roles: ADMIN_ROLES },
  { nameKey: "visitors", route: "/visitantes", icon: React.createElement(Group), roles: GLOBAL_ROLES },
  { nameKey: "users", route: "/usuarios", icon: React.createElement(AdminPanelSettings), roles: GLOBAL_ROLES },
  { nameKey: "links", route: "/settings/links", icon: React.createElement(Link), roles: GLOBAL_ROLES },
  { nameKey: "youtubeAccounts", route: "/youtube-contas", icon: React.createElement(YouTube), roles: GLOBAL_ROLES },
  { nameKey: "reports", route: "/reporter", icon: React.createElement(Assessment), roles: GLOBAL_ROLES },
  { nameKey: "help", route: "/ajuda", icon: React.createElement(HelpOutline), roles: GLOBAL_ROLES },
  { nameKey: "audit", route: "/auditoria", icon: React.createElement(ReceiptLong), roles: ADMIN_ROLES },
];

/** Itens exibidos diretamente no BottomNav (mobile); os demais ficam agrupados em "Mais". */
export const BOTTOM_NAV_PRIMARY_ROUTES = [
  "/dashboard",
  "/cameras",
  "/transmissoes-ao-vivo",
];
